import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch, Route } from 'react-router-dom';
import { IHasPageChangeRef } from '../../../../../../../main/interface/has-page-change';
import { useSetFourthLevelRoute } from '../../../../../../hooks/use-set-fourth-level-route';
import DisplayDataConfig from './config';

interface IMatch {
  path: string;
  params: {
    thirdLevelRoute: string;
  }
}

interface IDisplayDataProps {
  hasPageChangeRef: React.MutableRefObject<IHasPageChangeRef>;
}

class DisplayData {

  name = 'flutter-labels';

  render: React.FC<IDisplayDataProps> = (props) => {
    const match: IMatch = useRouteMatch();
    const dispatch = useDispatch();

    useSetFourthLevelRoute({
      dispatch,
      mainRoute: 'admin',
      subRoute: 'business-process',
      thirdLevelRoute: match.params.thirdLevelRoute,
      fourthLevelRoute: this.name,
      currentRoute: this.name
    });

    return (
      <>
        <Route path={`${match.path}`} exact>
          <DisplayDataConfig {...props} />
        </Route>
      </>
    );
  }
}

export default DisplayData;
